import React from 'react'
import { Grid, Typography } from '@mui/material'

import { createStyles, makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles';
import { CompetitorWithCurrentScore } from 'smartstream-widgets/components/PostMatchComponent/types'
import { getDefaultTheme } from 'smartstream-widgets/utils/getDefaultTheme';

const useStyles = makeStyles((theme: Theme) => createStyles({
	content: {
		maxWidth: 105,
		textAlign: 'center'
	},
	header: {
		borderBottom: '2px solid currentColor',
		color: theme.palette.text.primary,
		flexShrink: 0,
		flexWrap: 'nowrap',
		fontSize: 11,
		fontWeight: 'bold',
		lineHeight: 1.2,
		padding: `4px 0px 6px`,
		width: '100%'
	},
	overflowEllipsis: {
		display: 'block',
		textOverflow: 'ellipsis',
		overflow: 'hidden',
		whiteSpace: 'nowrap'
	},
	scorePredicted: {
		fontSize: 42,
		fontWeight: 600,
		fontFamily: `${theme.typography.variantFontFamily}, ${theme.typography.fontFamily}`,
		lineHeight: 1.1
	},
	scoreResultLoser: {
		color: theme.palette.text.secondary
	},
	scoreResultWinner: {
		color: theme.palette.text.primary
	}
}), { name: 'SingleTeamNameAndScore', defaultTheme: getDefaultTheme })

type Props = {
	classes: {
		[K in string]: string
	},
	competitor: CompetitorWithCurrentScore,
	winning?: boolean
}

function SingleTeamNameAndScore(props: Props) {
  const classes = useStyles({ classes: props.classes })
	const {
		competitor: {
			currentScore,
			displayName,
			officialName,
			firstName,
			secondName
		} = {},
		winning
	} = props

	return (
		<Grid
			container
			direction='column'
			wrap='nowrap' justifyContent='flex-end' className={classes.content}>
			<Typography className={classes.header} data-testid='single-team-name-and-score'>
				{
					(firstName && secondName) || (displayName && displayName[0] && displayName[1]) ?
						<>
							<span className={classes.overflowEllipsis}>{firstName || displayName[0]}</span>
							<span className={classes.overflowEllipsis}>{secondName || displayName[1]}</span>
						</>
						: officialName
				}
			</Typography>
			{(
				<Typography
					className={`${classes.scorePredicted} ${winning ? classes.scoreResultWinner : classes.scoreResultLoser}`}>
					{currentScore}
				</Typography>
			)}
		</Grid>
	)
}

export default SingleTeamNameAndScore
